export var CustomFieldType;
(function (CustomFieldType) {
    CustomFieldType[CustomFieldType["TEXT"] = 1] = "TEXT";
    CustomFieldType[CustomFieldType["MULTILINE_TEXT"] = 2] = "MULTILINE_TEXT";
    CustomFieldType[CustomFieldType["SINGLE_SELECT"] = 3] = "SINGLE_SELECT";
    CustomFieldType[CustomFieldType["MULTI_SELECT"] = 4] = "MULTI_SELECT";
    CustomFieldType[CustomFieldType["NUMBER"] = 5] = "NUMBER";
    CustomFieldType[CustomFieldType["BOOLEAN"] = 6] = "BOOLEAN";
    CustomFieldType[CustomFieldType["DATE"] = 7] = "DATE";
    CustomFieldType[CustomFieldType["EMAIL"] = 8] = "EMAIL";
    CustomFieldType[CustomFieldType["CURRENCY"] = 9] = "CURRENCY";
    CustomFieldType[CustomFieldType["URL"] = 10] = "URL";
    CustomFieldType[CustomFieldType["AGENTS"] = 11] = "AGENTS";
    CustomFieldType[CustomFieldType["GROUPS"] = 12] = "GROUPS";
    CustomFieldType[CustomFieldType["ATTACHMENT"] = 13] = "ATTACHMENT";
    CustomFieldType[CustomFieldType["MULTI_LEVEL"] = 14] = "MULTI_LEVEL";
})(CustomFieldType || (CustomFieldType = {}));
//# sourceMappingURL=custom-field-type.enum.js.map